import axios from '../../../services/axios';
import { AxiosResponse } from 'axios';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

type GetConnectedOrganizationsParams = {
  partnerId: string;
  orgId: string;
  userId: string;
};

export const getConnectedOrganizations = async ({
  partnerId,
  orgId,
  userId,
}: GetConnectedOrganizationsParams): Promise<AxiosResponse> => {
  try {
    const response = await axios.get(
      `${VITE_APP_API_URL}/auth-service/connected_partner_organization?partner=${partnerId}&account_id=${userId}_${orgId}`,
    );
    return response?.data;
  } catch (err: any) {
    console.error('err', err);
    return Promise.resolve<any>([]);
  }
};
